/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {ServiceError} from '@ion/core/src/types/services';

//bulk edit group
const selectBulkEditGroup            = ({adminAssets: {bulkEditGroup}}) => bulkEditGroup;
const selectBulkEditGroupShowDialog  = state => selectBulkEditGroup(state).isEditing;
const selectBulkEditGroupSelected    = state => selectBulkEditGroup(state).selected;
const selectBulkEditGroupShowLoading = state => selectBulkEditGroup(state).loading;
const selectBulkEditGroupResult      = state => selectBulkEditGroup(state).result;

//modular search
const selectModularSearch = ({adminAssets: {search}}) => search;

//edit
const selectEdit           = ({adminAssets: {edit}}) => edit;
const selectEditShowDialog = state => selectEdit(state).isEditing;
const selectEditIsView     = state => selectEdit(state).isView;
const selectEditSelected   = state => selectEdit(state).selected;
const selectEditResult     = state => selectEdit(state).result;

// audit
const selectAudit                  = ({adminAssets: {audit}}) => audit;
const selectAuditShowDialog        = state => selectAudit(state).isEditing;
const selectAuditSelected          = state => selectAudit(state).selected;
const selectAuditRecord            = state => selectAudit(state).auditRecord;
const selectAuditShowChangesDialog = state => selectAudit(state).showChangesDialog;

const selectAssetMove            = ({adminAssets: {move}}) => move;
const selectAssetMoveSelected    = state => selectAssetMove(state).selected;
const selectAssetMoveShowDialog  = state => selectAssetMove(state).isEditing;
const selectAssetMoveResult      = state => selectAssetMove(state).result;
const selectAssetviewMovedErrors = state => selectAssetMove(state).errors;
const selectAssetMoveShowLoading = state => selectAssetMove(state).loading;
const selectAssetviewMovedResult = state => selectAssetMove(state).viewMovedAssets;

export const bulkEditGroupShowDialogSelector = createSelector(
  selectBulkEditGroupShowDialog, (isEditing: boolean) => isEditing
);
export const bulkEditGroupSelectedAssetsSelector = createDeepEqualSelector(
  selectBulkEditGroupSelected, selected => selected
);
export const bulkEditGroupShowLoadingSelector = createSelector(
  selectBulkEditGroupShowLoading, (loading: boolean) => loading
);
export const bulkEditGroupResultSelector = createDeepEqualSelector(
  selectBulkEditGroupResult, result => result
);

export const modularSearchSelector = createDeepEqualSelector(
  selectModularSearch, search => search
);
export const editShowDialogSelector = createSelector(
  selectEditShowDialog, (isEditing: boolean) => isEditing
);
export const editIsViewSelector = createSelector(
  selectEditIsView, (isView: boolean) => isView
);
export const assetEditSelectedSelector = createDeepEqualSelector(selectEditSelected,
  selected => selected
);

export const assetEditResultSelector = createDeepEqualSelector(selectEditResult,
  result => result
);

export const assetAuditShowDialogSelector = createSelector(selectAuditShowDialog,
  (isEditing: boolean) => isEditing
);
export const assetAuditSelectedSelector = createDeepEqualSelector(selectAuditSelected,
  selected => selected
);
export const assetAuditRecordSelector = createDeepEqualSelector(selectAuditRecord,
  auditRecord => auditRecord
);
export const assetAuditShowChangesDialogSelector = createSelector(selectAuditShowChangesDialog,
  (showChangesDialog: boolean) => showChangesDialog
);

export const assetMoveShowDialogSelector = createSelector(
  selectAssetMoveShowDialog, (isEditing: boolean) => isEditing
);
export const assetMoveSelectedAssetsSelector = createDeepEqualSelector(
  selectAssetMoveSelected, selected => selected
);
export const assetMoveShowLoadingSelector = createSelector(
  selectAssetMoveShowLoading, (loading: boolean) => loading
);
export const assetMoveResultSelector = createDeepEqualSelector(
  selectAssetMoveResult, result => result
);
export const assetMoveErrorsSelector = createDeepEqualSelector(
  selectAssetviewMovedErrors, (errors: ServiceError[]): ServiceError[] => errors
);
export const adminAssetsViewMovedResultsSelector = createSelector(
  selectAssetviewMovedResult, (viewMovedAssets: boolean) => viewMovedAssets
);
